import React, { useState, useRef, useContext, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { useTranslation } from 'react-i18next';
import { setAppLanguage, LANGS } from '../i18n';
import { applyTheme, getStoredTheme, jeTamna } from '../theme';
import './login.css';
import Slika from './black-desk.jpg';
import Icon from './icon.jpg';
import { AuthContext } from '../Header/auth - context';
import { TabMenu } from 'primereact/tabmenu';
import { useDispatch } from "react-redux";
import checkVersion from '../custom/checkVersion';



const Login = (props) => {

    const auth = useContext(AuthContext);
    const dispatch = useDispatch();

    /* Prijavni ekran NIKAD nije retro. Pikselski izgled (mono pismo, debeli
       okviri, tvrde senke, raster) nema šta da traži na ekranu koji ima
       sopstvenu sliku i svoje dugmad — zato se za vreme prijave skida
       `data-retro` i tema se spusti na svetlu/tamnu osnovu.

       Izabrana tema se NE briše iz `localStorage`-a: `applyTheme` bi je
       prepisao, pa bi korisnik posle prijave dobio svetlu umesto svoje.
       Zato se menjaju samo atributi na <html>, a prava tema se vraća pri
       uspešnoj prijavi (niže, iz `data.user.tema`). */
    useEffect(() => {
        const koren = document.documentElement;
        const sacuvana = getStoredTheme();
        koren.setAttribute('data-theme', jeTamna(sacuvana) ? 'dark' : 'light');
        koren.removeAttribute('data-retro');
        return () => applyTheme(sacuvana);
    }, []);
    const { t, i18n } = useTranslation();
    const toast = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [facingRight, setFacingRight] = useState(true);
    const [isMoving, setIsMoving] = useState(false);
    const prevIndex = React.useRef(0);
    const movingTimer = React.useRef(null);

    const handleTabChange = (e) => {
        setFacingRight(e.index >= prevIndex.current);
        prevIndex.current = e.index;
        setActiveIndex(e.index);
        setIsMoving(true);
        if (movingTimer.current) clearTimeout(movingTimer.current);
        movingTimer.current = setTimeout(() => setIsMoving(false), 900);
    };

    const truckPos = ['8px', 'calc(50% - 140px)', 'calc(100% - 288px)'];

    const handleErrors = (response) => {
        if (response.ok) {
            return response.json();
        } else {
            throw response;
        }
    }
    
    const infoAlarmCheck = (token) => {
        const requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            }
          };
         fetch(
            process.env.REACT_APP_BACKEND_URL + "/alarms/info",
            requestOptions
          )
            .then(handleErrors)
            .then((result) => {
              if (result) {
                let fakture = result.filter(x => x.TIP === 'FaktureProvera');
                // Zbir svih grupa stiže gotov iz procedure — vidi App.js.
                let ukupno  = result.filter(x => x.TIP === 'Ukupno');
                setTimeout(()=>{
                    dispatch({
                        type: "COUNTER",
                        value: ukupno[0]?.ALARMI || 0
                      });
                    dispatch({
                        type: "COUNTER_INVOICE_CHECK",
                        value: fakture[0]?.ALARMI ?? 0
                      });
                },[100])
              }
            });
      };

    const planNoviCheck = (token) => {
        fetch(process.env.REACT_APP_BACKEND_URL + '/plan/novi_count', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        })
            .then(handleErrors)
            .then((result) => {
                dispatch({ type: 'PLAN_NOVI_SET', value: result.count || 0 });
                dispatch({ type: 'PLAN_NEPROCITANI_SET', value: result.neprocitani || 0 });
            })
            .catch(() => {});
    };
    const loginSubmitHandler = async () => {

        /* Verzija se NE proverava ovde nego posle uspešne prijave (vidi dno ovog
           handlera). Provera pre prijave je radila reload usred klika, pa je taj
           klik propadao i korisnik je morao da se prijavljuje drugi put. */

        let emailInput = document.getElementById('emaillogin').value.trim();
        let passwordInput = document.getElementById('passlogin').value;
        if (emailInput === "" || passwordInput === "") {
            toast.current.show({ severity: 'info', summary: 'Obaveštenje', detail: 'Unesite email i lozinku!', life: 3000 });
        } else {
            let requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: emailInput, password: passwordInput })
            };
            fetch(process.env.REACT_APP_BACKEND_URL + "/users/login", requestOptions)
                .then(handleErrors)
                .then(data => {
                    let companyID;
                    let companyName;
                    let state;
                    let id_drzava;

                    if(data.user.id_Company == null) {
                        companyID = data.user.firma_id
                        companyName = data.user.Naziv
                        state = data.user.Drzava
                        id_drzava = data.user.id_drzava
                    } else {
                        companyID = data.user.id_Company
                        companyName = data.user.Naziv_Company
                        state = data.user.Drzava
                        id_drzava = data.user.id_drzava
                    }
                    props.getUser(data.user)
                    auth.login(data.userId, data.token, data.user.name, data.user.surname)
                    /* Avatar iz ćaskanja — zaglavlje ga prikazuje pored izbora firme. */
                    dispatch({ type: 'AVATAR_SET', value: data.user.avatar || null });
                    infoAlarmCheck(data.token);
                    planNoviCheck(data.token);
                    fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetAvansAlarmCount', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + data.token },
                    }).then(r => r.json()).then(d => dispatch({ type: 'AVANS_ALARM_SET', value: d?.[0]?.AlarmCount || 0 })).catch(() => {});
                        dispatch({
                            type: "COMPANY",
                            value: 
                            {companyId: companyID,
                            companyName: companyName,
                            companyState: state,
                            companyCountryID: id_drzava}
                        });
                      dispatch({
                        type: "USER_ROLE",
                        value: 
                        {roleId: data.user.role_id}
                      });
                      dispatch({
                        type: "ESKALIRAN",
                        value:
                        {eskaliran: data.user.Eskaliran}
                      });
                      // Prava pristupa po modulima (Faza 1) — u store za kasniji enforce
                      const pravaSpremna = fetch(process.env.REACT_APP_BACKEND_URL + '/users/myPermissions', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + data.token },
                      }).then(r => r.json()).then(d => dispatch({ type: 'PERMISSIONS', value: Array.isArray(d) ? d : [] })).catch(() => {});
                      // Jezik aplikacije po operateru (iz DB) — postavi odmah po loginu
                      setAppLanguage(data.user.jezik || 'sr');
                      // Tema aplikacije po operateru (iz DB) — primeni na celu aplikaciju
                      applyTheme(data.user.tema || 'light');
                      dispatch({ type: 'THEME_SET', value: data.user.tema || 'light' });
                      dispatch({
                        type: "TRIP",
                        value: null
                      });
                    dispatch({
                        type: "COMPANY_SUB_U_SUB",
                        value:
                        {...data.sub_u_sub}
                      });

                      /* Tek sada provera verzije: prijava je gotova i upisana u store,
                         pa reload na novi bundle vraća korisnika PRIJAVLJENOG — jedan
                         klik, bez ponovnog kucanja lozinke.
                         Čeka se na prava pristupa jer se ona povlače samo pri prijavi;
                         reload pre toga bi ostavio korisnika bez njih do sledeće prijave. */
                      pravaSpremna.then(() => checkVersion({ sacuvajSesiju: true }));
                }).catch((error) => {
                    error.json().then(errorMessage => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: errorMessage.message, life: 3000 });
                        console.log(errorMessage);

                    })

                });
        }
    }

    const signUpSubmitHandler = () => {

        let nameInput = document.getElementById('nameSignUp').value;
        let surnameInput = document.getElementById('surnameSignUp').value;
        let emailInput = document.getElementById('emailSignUp').value.trim();
        let passwordInput = document.getElementById('passSignUp').value;
        let regCodeInput = document.getElementById('regCode').value;
        if (emailInput === "" || passwordInput === "" || nameInput === "" || surnameInput === "" || regCodeInput === "") {
            toast.current.show({ severity: 'info', summary: 'Obaveštenje', detail: 'Unesite sve prerekvizite forme!', life: 3000 });
        } else {
            let requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: emailInput, password: passwordInput, name: nameInput, surname: surnameInput, subscriptionCode: regCodeInput })
            };
            fetch(process.env.REACT_APP_BACKEND_URL + "/users/signup", requestOptions)
                .then(handleErrors)
                .then(data => {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: data.message, life: 3000 })
                     document.getElementById('nameSignUp').value = '';
                     document.getElementById('surnameSignUp').value = '';
                     document.getElementById('emailSignUp').value = '';
                     document.getElementById('passSignUp').value = '';
                     document.getElementById('regCode').value = '';
                    setActiveIndex(0);
                }).catch((error) => {
                    error.json().then(errorMessage => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: errorMessage.message, life: 3000 });
                        console.log(errorMessage);

                    })

                });
        }
    }



    const sendPassHandler = () => {
        let emailSend = document.getElementById('emailPassSend').value.trim();
   
        if (emailSend === "" || emailSend.includes('@') === false) {
            toast.current.show({ severity: 'warn', summary: 'Obaveštenje', detail: 'Unesite ispravan email!', life: 3000 });
        } else {
            let requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: emailSend })
            };
            fetch(process.env.REACT_APP_BACKEND_URL + "/users/passSend", requestOptions)
                .then(handleErrors)
                .then(data => {
                    toast.current.show({ severity: 'success', summary: 'Uspešno', detail: data.message, life: 3000 });
                    document.getElementById('emailPassSend').value = '';
                    setActiveIndex(0);
                }).catch((error) => {
                    error.json().then(errorMessage => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: errorMessage.message, life: 3000 });
                        console.log(errorMessage);

                    })

                });
        }
    }

    const items = [
        { label: t('login.tabPrijava'), icon: 'pi pi-user' },
        { label: t('login.tabRegistracija'), icon: 'pi pi-user-plus' },
        { label: t('login.tabNovaLozinka'), icon: 'pi pi-users' }
    ];
    return (
        <div id='login_screen'><Toast ref={toast} />

            <img id='login_background' src={Slika} alt="Login background" />
            <div id='loginform'>
                <img id='avatar' src={Icon} alt="Icon" />
                <div className="login-truck-strip">
                  <div
                    className={`login-truck${isMoving ? ' truck-moving' : ''}`}
                    style={{ left: truckPos[activeIndex], transform: facingRight ? 'none' : 'scaleX(-1)' }}
                  >
                    <svg width="280" height="73" viewBox="0 0 420 110" style={{ display: 'block' }}>
                      <defs>
                        <g id="wheel">
                          <circle r="14" fill="#111" stroke="#444" strokeWidth="1.5" />
                          <circle r="8" fill="#2a2a2a" />
                          <circle r="3" fill="#666" />
                          {[0, 45, 90, 135].map((deg, i) => (
                            <line key={i} x1="0" y1="-8" x2="0" y2="-14" stroke="#777" strokeWidth="1.5" transform={`rotate(${deg})`} />
                          ))}
                        </g>
                      </defs>

                      {/* telo prikolice */}
                      <rect x="10" y="18" width="235" height="55" rx="3" fill="#f7f7f7" stroke="#cfcfcf" strokeWidth="1" />
                      {/* gornja linija */}
                      <rect x="10" y="18" width="235" height="5" fill="#dadada" />
                      {/* paneli */}
                      {[55, 100, 145, 190].map((x, i) => (
                        <line key={i} x1={x} y1="23" x2={x} y2="73" stroke="#dfdfdf" strokeWidth="1" />
                      ))}
                      {/* hladnjača */}
                      <rect x="240" y="25" width="22" height="35" rx="2" fill="#8d8d8d" stroke="#666" strokeWidth="0.7" />
                      {[31, 37, 43, 49].map((y, i) => (
                        <rect key={i} x="245" y={y} width="12" height="2" fill="#666" />
                      ))}
                      {/* donja plava traka */}
                      <rect x="10" y="63" width="235" height="10" fill="#1f3f95" />
                      {/* dekoracija */}
                      {[28, 52, 76, 100, 124, 148, 172, 196, 220].map((x, i) => (
                        <polygon key={i} points={`${x-5},68 ${x},63 ${x+5},68 ${x},73`} fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="0.8" />
                      ))}
                      {/* tekst */}
                      <g style={{ transformBox: 'fill-box', transformOrigin: 'center', transform: facingRight ? 'none' : 'scaleX(-1)' }}>
                        <text x="128" y="43" fontFamily="Arial" fontWeight="800" fontSize="16" fill="#1a1f45" textAnchor="middle" letterSpacing="1">TMS</text>
                        <text x="128" y="58" fontFamily="Arial" fontSize="9" fill="#777" textAnchor="middle" letterSpacing="4">TRANSPORT</text>
                      </g>
                      {/* zadnja svetla */}
                      <rect x="10" y="25" width="4" height="12" rx="1" fill="#d32020" />
                      <rect x="10" y="52" width="4" height="12" rx="1" fill="#d32020" />
                      <rect x="10" y="40" width="4" height="8" rx="1" fill="#ffc107" />
                      {/* šasija */}
                      <rect x="16" y="74" width="210" height="7" rx="2" fill="#353535" />
                      {/* nogare */}
                      <rect x="175" y="74" width="5" height="16" fill="#777" />
                      <rect x="171" y="88" width="13" height="3" rx="1" fill="#666" />
                      {/* spoj */}
                      <path d="M220 74 L245 74 L255 64 L230 64 Z" fill="#2d2d2d" />

                      {/* šasija tegljača */}
                      <rect x="245" y="74" width="115" height="7" rx="2" fill="#353535" />
                      {/* kabina */}
                      <path d="M275 18 L350 18 Q365 18 365 30 L365 65 Q365 75 355 75 L255 75 L255 35 Q255 18 275 18" fill="#f3f2ea" stroke="#c7c7bf" strokeWidth="1" />
                      {/* plavi gornji deo */}
                      <rect x="285" y="22" width="58" height="13" rx="3" fill="#1f3f95" />
                      <g style={{ transformBox: 'fill-box', transformOrigin: 'center', transform: facingRight ? 'none' : 'scaleX(-1)' }}>
                        <text x="314" y="31" fontFamily="Arial" fontWeight="700" fontSize="8" fill="white" textAnchor="middle" letterSpacing="1">TMS</text>
                      </g>
                      {/* prozori */}
                      <rect x="292" y="38" width="22" height="18" rx="2" fill="#1d2638" />
                      <path d="M318 38 L347 38 Q356 38 356 45 L356 56 L318 56 Z" fill="#1d2638" />
                      {/* vrata */}
                      <line x1="316" y1="18" x2="316" y2="75" stroke="#c3c3bb" strokeWidth="1.3" />
                      {/* far */}
                      <rect x="356" y="56" width="7" height="10" rx="1" fill="#ffd54a" />
                      {/* maska */}
                      <rect x="356" y="36" width="10" height="20" rx="1" fill="#c9c9c1" />
                      {[40, 45, 50].map((y, i) => (
                        <line key={i} x1="357" y1={y} x2="365" y2={y} stroke="#9a9a9a" strokeWidth="1" />
                      ))}
                      {/* auspusi */}
                      <rect x="328" y="10" width="4" height="14" rx="2" fill="#999" />
                      <rect x="336" y="10" width="4" height="14" rx="2" fill="#999" />
                      {/* rezervoar */}
                      <rect x="286" y="78" width="40" height="10" rx="2" fill="#8d8d8d" />
                      {/* blatobrani */}
                      <path d="M250 74 Q263 55 276 74" fill="#2f2f2f" />
                      <path d="M279 74 Q292 55 305 74" fill="#2f2f2f" />

                      {/* TOČKOVI: outer g = pozicija, inner g.wheel-spoke = rotacija */}
                      {[55, 95, 135, 268, 298, 350].map((cx) => (
                        <g key={cx} transform={`translate(${cx},84)`}>
                          <g className="wheel-spoke">
                            <use href="#wheel" />
                          </g>
                        </g>
                      ))}

                      {/* senka */}
                      <ellipse cx="190" cy="100" rx="170" ry="5" fill="rgba(0,0,0,0.12)" />
                    </svg>
                  </div>
                </div>
                <TabMenu id='modelTab' activeIndex={activeIndex} onTabChange={handleTabChange} style={{ marginBottom: '0' }} model={items} />
                <select
                    className="login-lang-dropdown"
                    value={i18n.language}
                    onChange={e => setAppLanguage(e.target.value)}
                    title="Jezik / Language"
                >
                    {LANGS.map(l => (
                        <option key={l.code} value={l.code}>{l.code.toUpperCase()}</option>
                    ))}
                </select>
                <div className="login-body">
                {activeIndex === 0 && <h3>{t('login.naslovPrijava')}</h3>}
                {activeIndex === 0 &&
                    <form id="login" onSubmit={e => e.preventDefault()}>
                        <div className="inputform">
                            <label className="form-label">{t('login.email')}</label>
                            <input type="email" className="form-control" id="emaillogin" placeholder={t('login.phEmail')} />
                        </div>
                        <div className="inputform">
                            <label className="form-label">{t('login.lozinka')}</label>
                            <input type="password" className="form-control" id="passlogin" autoComplete="on" placeholder={t('login.phLozinka')} />
                        </div>
                        <button type="submit" onClick={loginSubmitHandler} className="loginButtons">{t('login.dugmePrijava')}</button>
                    </form>
                }
                {activeIndex === 1 && <h3>{t('login.naslovRegistracija')}</h3>}
                {activeIndex === 1 ? (
                    <form onSubmit={e => e.preventDefault()}>
                        <div id="firstPart">
                            <div className="inputform">
                                <label className="form-label">{t('login.ime')}</label>
                                <input type="text" className="form-control" id="nameSignUp" placeholder={t('login.phIme')} />
                            </div>
                            <div className="inputform">
                                <label className="form-label">{t('login.prezime')}</label>
                                <input type="text" className="form-control" id="surnameSignUp" placeholder={t('login.phPrezime')} />
                            </div>
                        </div>
                        <div id='signup'>
                            <div className="inputform">
                                <label className="form-label">{t('login.email')}</label>
                                <input type="email" className="form-control" id="emailSignUp" placeholder={t('login.phEmail')} />
                            </div>
                            <div className="inputform">
                                <label className="form-label">{t('login.lozinka')}</label>
                                <input type="password" className="form-control" autoComplete="on" id="passSignUp" placeholder={t('login.phLozinka')} />
                            </div>
                            <div className="inputform">
                                <label className="form-label">{t('login.regKod')}</label>
                                <input type="text" className="form-control" id="regCode" placeholder={t('login.phRegKod')} />
                            </div>
                            <button type="submit" onClick={signUpSubmitHandler} className="loginButtons">{t('login.dugmeRegistracija')}</button>
                        </div>
                    </form>
                ) : null}
                {activeIndex === 2 && <h3>{t('login.naslovNovaLozinka')}</h3>}
                {activeIndex === 2 ? (
                    <form onSubmit={e => e.preventDefault()}>
                        <div className="inputform">
                            <label className="form-label">{t('login.email')}</label>
                            <input type="email" className="form-control" id="emailPassSend" placeholder={t('login.phEmail')} />
                        </div>
                        <button type="submit" onClick={sendPassHandler} className="loginButtons">{t('login.dugmePosalji')}</button>
                    </form>
                ) : null}
                </div>
            </div>

        </div>
    );
};

export default Login;